import aboutStoreImage from '../assets/store-front.png';
import { AboutPageDetails } from '../types/AboutPageDetails';

export const aboutPageData: AboutPageDetails = {
    heroTitle: 'Your Trusted Convenience Store Network.',
    
    storySection: {
        title: 'Our Story',
        content: `
            SSA Retail Group Limited was founded with a simple mission: to provide convenient access to quality products 
            and exceptional service in our communities. What started as a single convenience store has grown 
            into a network of stores, each committed to serving our customers' daily needs.
            We believe that convenience stores should be more than just places to buy things – they should be 
            community hubs where neighbors meet, families shop, and everyone feels welcome.
        `,
    },

    storyImage: {
        src: aboutStoreImage,
        alt: "Exterior view of an SSA Retail Group Limited store front",
    },

    highlightBoxes: [
        {
            title: 'Our Mission',
            items: 'To provide convenient access to quality products and exceptional service, making everyday life easier for our customers and strengthening the communities we serve.',
            bgColorClass: 'bg-blue-50',
        },
        {
            title: 'Our Values',
            items: [
                'Quality products at fair prices',
                'Friendly, helpful service',
                'Community involvement',
                'Clean, safe stores',
                'Continuous improvement',
            ],
            bgColorClass: 'bg-green-50',
        },
    ],
};